export const SendingQuery = 0;
export const PeerResponse = 1;
export const FinalPeer = 2;
export const QueryError = 3;
export const Provider = 4;
export const Value = 5;
export const AddingPeer = 6;
export const DialingPeer = 7;